import React from 'react';

export interface PersonalRecordRow {
  key: string;
  label: string;
  value: string;
  magnitude?: number;
}
/** A local visual comparison, with explicit values and no rankings or scores. */
export function PersonalRecordRows({ rows, selected, onSelect, label }: {
  rows: PersonalRecordRow[];
  selected: string;
  onSelect: (key: string) => void;
  label: string;
}) {
  const max = Math.max(0, ...rows.map(row => row.magnitude ?? 0));
  return <div className="performance-records" role="group" aria-label={label}>
    {rows.map(row => <button type="button" key={row.key} className="performance-records__row" aria-pressed={row.key === selected} onClick={() => onSelect(row.key)}>
      <span>{row.label}</span><bdi>{row.value}</bdi>
      {rows.length > 1 && max > 0 && row.magnitude != null && <span className="performance-records__track" aria-hidden="true"><span style={{ width: `${Math.max(0, Math.min(100, row.magnitude / max * 100))}%` }} /></span>}
    </button>)}
  </div>;
}
